import React, { useState, useEffect } from 'react';
import { Typography, Button } from '@mui/material';
import '../styles/common.css';
import Confetti from 'react-confetti'
import ThankyouIcon from '../assets/thankyou.svg';
import moment from "moment/moment";
import { appConfig } from '../app-config';
import langDetails from '../components/MultiLanguage/language.json';
import { savedPayments, sendBillingDetails } from './redux/actions';
import SubscriptionSuccess from './SubscriptionSuccess';

const DonationSuccess = ({ sharedData, updateSharedData, handleNext }) => {
  const [showConfetti, setShowConfetti] = useState(true);
  const [paymentId, setPaymentId] = useState(sharedData?.confirmPaymentId || '');
  const [moreProjectUrl, setMoreProjectUrl] = useState('');
  const [exclusiveContentUrl, setExclusiveContentUrl] = useState('');
  const [paymentSuccessData, setPaymentSuccessData] = useState('');
  const [isSubscription, setIsSubscription] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const lang = langDetails[sharedData?.language];

  useEffect(()=>{
    const originalString = sharedData?.donationAmount?.currency;
    const lowercaseStringCurrency = originalString?.toLowerCase();
    const apiReq = {
      "donorDetails": sharedData?.enableReceipting ? (sharedData?.donorData || {}) : {
        reciveCheck: "true",
        firstName: "",
        lastName: "",
        addressOne: "",
        addressTwo: "",
        city: "",
        country: "",
        postalCode: "",
        province: "",
        youGive: "",
        givesomeTip: "",
        total: ""
      },
      "amount": sharedData?.donationAmount?.totalAmount,
      "youGive":sharedData?.donationAmount?.youGive,
      "givesomeTip": sharedData?.donationAmount?.givesomeTip,
      "givesomeTipPercentage": sharedData?.donationAmount?.givesomeTipPercentage,
      "givecardAmount":Number(sharedData?.rewardApplied?.creditApplied),
      "givecardId":Number(sharedData?.rewardApplied?.givecardId) || Number(sharedData?.applyCardData?.givecardId),
      "givacardBalance":Number(sharedData?.rewardApplied?.givacardBalance),
      "currency": lowercaseStringCurrency,
      "description": sharedData?.donationAmount?.description+' (to '+sharedData.projectName+')',
      "projectId": sharedData?.projectId,
      "supplierId": sharedData?.supplier_id || "",
      "givecardCode": sharedData?.rewardApplied?.rewardCode?.toUpperCase() || "",
      "userId": sharedData?.userId  !== "None"  ? sharedData?.userId : null,
      "paymentIntentId": sharedData?.paymentIntent?.paymentIntentId,
      "isEmailOptIn": sharedData?.venorId ? (sharedData?.isemailoptIn ? true : false): null,
      "vendorId": sharedData?.venorId || null,
      "isSaveCardDetails": sharedData?.isSaveCardDetails || false,
    }
    if(sharedData?.paymentIntent?.paymentIntentId) {
      sendBillingDetails(apiReq).then((response) => {
            if(response.code && response.code  !== "") {
              setIsLoading(false);
              return
            }
            sessionStorage.removeItem("sharedData");

            if (response && response.data && response.data.status === 200) {
              if(sharedData?.isSaveCardDetails && sharedData?.singlePaymentMethodId) {
                const apiReq = {
                  paymentMethodId: sharedData?.singlePaymentMethodId,
                  csrfToken: sharedData?.csrfToken || '',
                  sessionId: sharedData?.sessionId
                }
                savedPayments(apiReq)
              }
              setExclusiveContentUrl(response.data.data.exclusiveContentUrl);
              setMoreProjectUrl(response.data.data.moreProjectUrl);
              setPaymentId(response.data.data.paymentId || sharedData?.confirmPaymentId || '');
              setPaymentSuccessData(response.data.data);
              console.log('subscription:', response.data.data.subscription);
              setIsSubscription(response.data.data.subscription === true);
              sessionStorage.removeItem("sharedData");
            }
            if (response && response.data && response.data.status !== 200) {
              // setErrorMessage(response.data.message);
            }
            setIsLoading(false);
          })
          .catch((error) => {
            console.error('Error fetching data:', error);
          //   setErrorMessage(error.message);
            setIsLoading(false);
          });
        } else {
          setIsLoading(false);
        }
  },[])
  const moreProjectRedrection = () => {
    window.parent.postMessage({ action: 'loadUrl', url: sharedData?.applyCardData?.moreProjectUrl ? sharedData?.applyCardData?.moreProjectUrl : moreProjectUrl || appConfig.WEB_URL }, "*");
  }
  const exclusiveContentRedrection = () => {
    window.parent.postMessage({ action: 'loadUrl', url: sharedData?.applyCardData?.exclusiveContentUrl ? sharedData?.applyCardData?.exclusiveContentUrl : exclusiveContentUrl || appConfig.WEB_URL }, "*");
  }
  const divStyle = {
    backgroundImage: `url(${sharedData?.projectImage ? `${appConfig.WEB_URL}/${sharedData?.projectImage}` : ThankyouIcon})`,
    backgroundSize: 'cover',
    width: '340px',
    height: '240px',
    borderRadius: 20,
    marginTop: 10,
    marginBottom: 10
  };
  const continueDonation = () => {
    if((!sharedData?.userId  || sharedData?.userId  === "None") ) {
      //Anonymous  Flow
      handleNext(5);
    }  else {
      //Login Flow
      handleNext(0)
    }
  }
  
  setTimeout(() => {
    setShowConfetti(false);
  }, 10000);

  if (isLoading) {
    return (
      <div style={{ textAlign: 'center', minHeight: 400 }}>
        <div className="skeleton-block" style={{ height: 24, width: '60%', margin: '35px auto 20px' }} />
        <div className="skeleton-block" style={{ height: 240, width: 340, margin: '0 auto 20px', borderRadius: 20 }} />
        <div className="skeleton-block" style={{ height: 48, width: '100%', marginBottom: 10 }} />
        <div className="skeleton-block" style={{ height: 48, width: '100%' }} />
      </div>
    );
  }

  if (isSubscription) {
    return (
      <SubscriptionSuccess
        sharedData={sharedData}
        paymentId={paymentId}
        moreProjectRedrection={moreProjectRedrection}
        exclusiveContentRedrection={exclusiveContentRedrection}
      />
    );
  }

  return (
    <><div style={{ textAlign: 'center', minHeight: 400, position: 'relative', top: '-24px' }}>
      {showConfetti && 
      <div style={{position: 'relative', zIndex: 0}}>
      <Confetti width={window.innerWidth}
          height={window.innerHeight}
          numberOfPieces={200}
          opacity={0.7}
        />
        </div>
      }
      <div style={{position: 'relative'}}>
      <div>
        <Typography className='big-head mb-10' style={{paddingTop: 35, color:'#111'}}>{lang?.thankyou}!</Typography>
        <Typography className="lg-normal-text mb-20" style={{color:'#111111BF'}}>{lang?.weCantWaitToShowDiff} <br/>{lang?.youHaveJustMade}</Typography>
      </div>
      {sharedData?.paymentIntent?.paymentIntentId && (
        <div style={{ textAlign: 'center' }}>
          <Typography className="normal-text mb-20">{lang?.confirmationNumber}: {paymentId || '-'}</Typography>
        </div>
        )}
        <div className="img-container mb-20">
          <div style={divStyle}></div>
        </div>
        <div className='btn-holder mb-10'>
          <Button className="normal-text outlined-black-btn lin-gradient"  style={{textTransform: 'capitalize', width: '100%', borderRadius: 12, backgroundColor: '#fff'}} variant='outlined' onClick={moreProjectRedrection}>
          <p className='lg-btn-text'>{((sharedData?.applyCardData?.moreProjectLabelName) ? (sharedData?.applyCardData?.moreProjectLabelName) : (paymentSuccessData?.moreProjectLabelName)) || lang?.moreProjects }</p>
          </Button>
          <Button className="normal-text default-btn"  style={{width: '100%'}} variant='contained' onClick={()=>{
             if(!sharedData?.singlePaymentMethodId || sharedData?.singlePaymentMethodId === ""){continueDonation();} else {exclusiveContentRedrection()}
          }}>
          <p className='lg-btn-text'>{(!sharedData?.singlePaymentMethodId || sharedData?.singlePaymentMethodId === "") ? (lang?.addAdditionalDonation) : ((sharedData?.applyCardData?.exclusiveContentLabelName) ? (sharedData?.applyCardData?.exclusiveContentLabelName) : (paymentSuccessData?.exclusiveContentLabelName)) || lang.exclusiveContent  }</p>

          </Button>
      </div>
      {/* <div className='rect-div'></div> */}

    </div>
  </div>
  </>
  );
}

export default DonationSuccess;

